import { TOrderDetails } from "./order-details.type";

type TProduct = {
    productId: string;
    upc: string | null;
    itemId: string;
};

export type TUnavailableProduct = {
    productId: string;
    size: string;
};

export type TOrderDetailsItemsSummaryResponse = {
    products: TProduct[];
    unavailableProducts: TUnavailableProduct[];
};

export const getOrderProductsSummary = (
    upcField: string,
    orderDetails?: TOrderDetails
): TOrderDetailsItemsSummaryResponse => {
    const unavailableProducts = [];

    const orderDetailsSummary = ((orderDetails || {}).__line_items || []).reduce((result, { __ref, __item, sizes }) => {
        return result.concat(
            sizes.reduce((result, { size, upc, _id }) => {
                const sizeDetails = __item.__sizes.find(({ __size }) => __size === size);
                if (sizeDetails || (upc && _id)) {
                    return result.concat({
                        productId: __ref,
                        upc: sizeDetails?.[upcField] || upc || null,
                        itemId: sizeDetails?._id || _id,
                    });
                }

                unavailableProducts.push({
                    size,
                    productId: __ref,
                });

                return result;
            }, [])
        );
    }, []);

    return {
        unavailableProducts,
        products: orderDetailsSummary,
    };
};
